import * as tf from '@tensorflow/tfjs'

const MOBILE_NET_INPUT_WIDTH = 224
const MOBILE_NET_INPUT_HEIGHT = 224

export const trainSingleModel = async ({
    modelData,
    mobilenet,
    camModels,
    setModelDetails,
}) => {
    const processCapturedImages = async (eachClass, allTensor) => {
        const { capturedImages } = eachClass
        for (let imageSrc of capturedImages) {
            const img = new Image()
            img.src = imageSrc

            await new Promise((resolve) => {
                img.onload = async () => {
                    const imgTensor = tf.browser.fromPixels(img)
                    const resized = tf.image.resizeBilinear(
                        imgTensor,
                        [MOBILE_NET_INPUT_HEIGHT, MOBILE_NET_INPUT_WIDTH],
                        true
                    )
                    const normalized = resized.div(255)
                    const features = mobilenet
                        .predict(normalized.expandDims())
                        .squeeze()

                    const featureArray = await features.array()
                    allTensor.push(featureArray)

                    imgTensor.dispose()
                    resized.dispose()
                    normalized.dispose()
                    features.dispose()

                    resolve()
                }
            })
        }
    }

    const classes = modelData.ImageClasses

    let inputs = []
    let outputs = []
    let CLASS_NAMES = []
    let count = 0

    for (let key in classes) {
        const eachClass = classes[key]
        let allTensor = []

        await processCapturedImages(eachClass, allTensor)

        if (!allTensor.length) continue

        CLASS_NAMES.push(eachClass.className)

        allTensor.forEach((tensor) => {
            inputs.push(tensor)
            outputs.push(count)
        })

        count++
    }

    if (CLASS_NAMES.length < 2) return

    tf.util.shuffleCombo(inputs, outputs)

    const xs = tf.tensor2d(inputs)
    const labelsTensor = tf.tensor1d(outputs, 'int32')
    const ys = tf.oneHot(labelsTensor, CLASS_NAMES.length)

    const model = tf.sequential()

    model.add(
        tf.layers.dense({
            inputShape: [inputs[0].length],
            units: 128,
            activation: 'relu',
        })
    )

    model.add(
        tf.layers.dense({
            units: CLASS_NAMES.length,
            activation: 'softmax',
        })
    )

    model.compile({
        optimizer: 'adam',
        loss: 'categoricalCrossentropy',
        metrics: ['accuracy'],
    })

    await model.fit(xs, ys, {
        epochs: modelData.epochs,
        batchSize: modelData.batchSize,
        shuffle: true,
    })

    // Per-type head key so a model can hold several trained types at once.
    const saveKey = modelData.saveKey || modelData.modelId
    await model.save(`indexeddb://${saveKey}`)

    xs.dispose()
    ys.dispose()
    labelsTensor.dispose()
    model.dispose()
    let updatedModels = [...camModels]
    const index = updatedModels.findIndex(
        (m) => m.modelId === modelData.modelId
    )

    if (index !== -1) {
        const type = modelData.trainedType || 'face'
        updatedModels[index].isGenerateTensor = true
        updatedModels[index].classLabels = CLASS_NAMES
        updatedModels[index].trainedTypes = {
            ...(updatedModels[index].trainedTypes || {}),
            [type]: true,
        }
    }

    setModelDetails(updatedModels)
}
